import styled from 'styled-components';
import { body2, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { ErrorText as ErrorMessage } from 'ui/formField';

export const StyledConversionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.base};
  width: 100%;
`;

export const StyledAttributionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing.threeEights};
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: fit-content;
  input {
    width: ${pxToRem(50)};
  }
`;

export const RadioRow = styled.div`
  ${body2}
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
`;

export const AttributeDetails = styled.div`
  ${body2}
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;

export const ErrorWrapper = styled.div`
  display: flex;
  margin-left: ${pxToRem(32)};
`;
export const ErrorText = styled(ErrorMessage)`
  margin: 0;
`;
